.ux-accordion {
  display: block;
  max-width: 100%;

  &__button {
    background: none;
    border: 0;
    line-height: 1.6;
    text-align: start;
    padding: 0;
  }

  &__title-container {
    align-items: center;
    border-bottom: 1px solid $color-gray-borders;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding: 15px;
    transition-delay: $animationSpeed-fast;

    @container style(--trumpf-ux-animations: disabled) {
      transition: none !important;
    }

    @media only screen and (width >=768px) {
      padding: 20px 30px;
    }

    >* {
      display: block;
      margin: 0;
      max-width: 80%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    ux-icon[name="chevron-down"] {
      font-size: $size-text-small;
      margin-left: 20px;
      transition: transform $animationSpeed-fast $animationEasing-ease;
    }
  }

  &__content-container {
    max-height: 0;
    overflow: hidden;

    transition: max-height 0.2s ease-out, padding $animationSpeed-fast $animationEasing-ease;

    @container style(--trumpf-ux-animations: disabled) {
      transition: none !important;
    }

    @media only screen and (width >=768px) {
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  &--active .ux-accordion__content-container {
    padding: 20px 0 30px;

    @media only screen and (width >=768px) {
      padding: 30px 30px 45px;
    }
  }

  &--active .ux-accordion__title-container {
    ux-icon[name="chevron-down"] {
      transform: rotate(180deg);
    }
  }

  &--active .ux-accordion__content-container {
    border-bottom: 1px solid $color-gray-borders;
  }

  &--full-title {
    .ux-accordion__title-container>* {
      overflow: auto;
      white-space: normal;
    }
  }
}

.ux-accordion--grey-shadow {
  .ux-accordion__title-container {
    align-items: flex-start;
    background-color: $color-blue-6;
    border-bottom: 0;
    box-shadow: 0 7px 22px rgb(19 19 19 / 8%);
    margin-bottom: 15px;
    padding: 15px 30px;
  }

  .ux-accordion__title-container>* {
    overflow: auto;
    white-space: normal;
  }

  .ux-accordion__content-container {
    border-bottom: 0;
  }
}